import { motion } from "framer-motion";

export default function LoadingScreen() {
  return (
    <>
      <div className="loading-screen">
        <motion.svg
          height="100%"
          strokeMiterlimit="10"
          version="1.1"
          viewBox="0 0 1024 1024"
          width="100%"
          xmlns="http://www.w3.org/2000/svg"
          initial="hidden"
          animate="visible"
        >
          <motion.path
            className="path"
            // create svg path for character y for me
            d="
M 186.56 138.4 C 222.08 25.76 155.2 23.2 84.8 75.04 C 64.32 114.72 36.16 153.12 241.92 75.04 C 316.16 48.48 361.92 30.88 288.32 252 C 288.64 388.64 433.6 369.12 483.2 295.52 C 516.2667 233.44 531 168 596 104 C 643 54 659 53 711.68 60 C 658 65 619 118 574 180 C 529 246 521.92 270.56 482.88 297.44 C 464.64 376.48 412.16 474.08 344.96 531.36 C 261.76 580.64 161.28 531.04 185.6 488.8 C 208.64 432.16 268.8 443.04 421.12 499.68 C 485.12 527.52 546.56 546.72 609.6 500.96 C 669.44 447.2 689 405 653 362 C 596 322 562.88 356.32 527.68 379.04 C 471.68 428.96 405.44 509.6 378.24 592.48 C 307.84 714.72 484.16 693.92 556 630 C 687.04 513.76 819.52 559.52 738 694 C 631.04 804 475.84 932.32 394.88 948.96 C 248.32 986.4 246.72 892.64 328.64 818.4 C 385.92 760.16 425.92 785.12 402.56 836.64 C 376 873.44 330.88 875.04 324.48 851.68 C 325.76 786.4 289.28 775.52 256 798.56 C 237.76 820.64 218.56 818.08 214.72 803.36"
            opacity="1"
            stroke="#ffffff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="30"
            variants={pathVariants}
          />
        </motion.svg>
      </div>
    </>
  );
}

const pathVariants = {
  hidden: {
    opacity: 0,
    pathLength: 0,
  },
  visible: {
    opacity: 1,
    pathLength: 1,
    transition: { duration: 2, ease: "easeInOut" },
  },
};
